import { IDesignerState } from '../../../typings';
import { createSelector } from 'reselect';
import { INITIAL_ZOOM_LEVEL } from '../../utils';

const getZoomFactor = (state: IDesignerState) => state.userReducer.zoomLevel;

export const getZoomAdjFactor = createSelector([getZoomFactor], zoomLevel => {
	return (INITIAL_ZOOM_LEVEL / zoomLevel) * 0.25;
});
